<template>
    <svg t="1659318540934" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2468" width="200" height="200">
        <path
            d="M256 213.333333h512a42.666667 42.666667 0 0 1 42.666667 42.666667v512a42.666667 42.666667 0 0 1-42.666667 42.666667H256a42.666667 42.666667 0 0 1-42.666667-42.666667V256a42.666667 42.666667 0 0 1 42.666667-42.666667z"
            p-id="2469" fill="#ffffff"></path>
    </svg>
</template>
